import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=0180cf3a&"
import script from "./thumbnail.vue?vue&type=script&lang=js&"
export * from "./thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./thumbnail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports